import React, { lazy } from 'react';

const FlashcardsPageContainer = lazy(() => import('./FlashcardsPageContainer'));

export const AsyncFlashcardsPageContainer = () => <FlashcardsPageContainer />;
